const done = { status: 'done', completed: { year: 2026, month: 10 } };
const planned = { status: 'planned' };

const base = [
  ['prontuario-paciente', done],
  ['receituario', planned],
  ['atestado', planned],
  ['pedido-exame-encaminhamento', planned],
  ['termo-consentimento', planned],
  ['plano-tratamento-orcamento', planned],
  ['financeiro-clinica', planned],
  ['producao-comissao', planned],
  ['estoque-materiais', planned],
  ['convenios-ficha', planned],
  ['relatorios-clinica', planned],
  ['whatsapp-automatico', planned],
  ['lista-espera', planned],
  ['consultas-recorrentes', done],
  ['lembrete-retorno', planned],
  ['exportar-dados', planned],
  ['assinatura-pix', planned],
];

function build(copy) {
  return base.map(([id, meta], index) => ({
    id,
    order: index,
    status: meta.status,
    ...(meta.completed ? { completed: meta.completed } : {}),
    title: copy[id].title,
    description: copy[id].description,
  }));
}

const pt = {
  'prontuario-paciente': {
    title: 'Prontuário completo do paciente',
    description: 'Anamnese, alergias, medicamentos, observações e histórico de atendimentos na mesma ficha, junto do odontograma, do mapa HOF e dos anexos que você já usa.',
  },
  receituario: {
    title: 'Receituário com impressão',
    description: 'O profissional preenche a receita e imprime ou gera o PDF com os dados do paciente e da clínica.',
  },
  atestado: {
    title: 'Atestado e declaração de comparecimento',
    description: 'Emissão e impressão pelo profissional, com data e horário do atendimento.',
  },
  'pedido-exame-encaminhamento': {
    title: 'Pedido de exame e encaminhamento',
    description: 'Documento padrão para solicitar exame ou encaminhar o paciente, pronto para imprimir.',
  },
  'termo-consentimento': {
    title: 'Termo de consentimento',
    description: 'Modelos para entregar ao paciente, com impressão e registro na ficha.',
  },
  'plano-tratamento-orcamento': {
    title: 'Plano de tratamento e orçamento',
    description: 'Procedimentos, valores e condições de pagamento para apresentar ao paciente antes de começar.',
  },
  'financeiro-clinica': {
    title: 'Financeiro da clínica',
    description: 'Contas a receber e baixa do pagamento do atendimento em dinheiro, Pix ou cartão. É separado da assinatura do ÁgilOdonto.',
  },
  'producao-comissao': {
    title: 'Produção e comissão por profissional',
    description: 'Quanto cada profissional produziu no período e a comissão combinada com a clínica.',
  },
  'estoque-materiais': {
    title: 'Estoque de materiais',
    description: 'Entrada e saída de materiais, com alerta quando o estoque chegar ao mínimo.',
  },
  'convenios-ficha': {
    title: 'Convênios na ficha do paciente',
    description: 'Convênio do paciente e registro do atendimento conveniado, sem integração com operadoras por enquanto.',
  },
  'relatorios-clinica': {
    title: 'Relatórios da clínica',
    description: 'Faltas, pacientes novos e produção do período, para acompanhar a clínica sem planilha.',
  },
  'whatsapp-automatico': {
    title: 'WhatsApp automático',
    description: 'Lembrete e confirmação da consulta pelo WhatsApp, além do e-mail que já sai hoje.',
  },
  'lista-espera': {
    title: 'Lista de espera',
    description: 'Fila de pacientes para encaixe quando abrir um horário na agenda.',
  },
  'consultas-recorrentes': {
    title: 'Consultas recorrentes',
    description: 'Retornos e manutenções repetidos na agenda, sem remarcar um a um.',
  },
  'lembrete-retorno': {
    title: 'Lembrete de retorno',
    description: 'Aviso quando a revisão do paciente estiver chegando, para a clínica chamar na hora certa.',
  },
  'exportar-dados': {
    title: 'Exportar os dados da clínica',
    description: 'Uma cópia dos pacientes e da agenda para a clínica levar os próprios dados quando quiser.',
  },
  'assinatura-pix': {
    title: 'Pagar a assinatura do ÁgilOdonto por Pix',
    description: 'Pagamento do plano por Pix. O cartão continua disponível.',
  },
};

const en = {
  'prontuario-paciente': {
    title: 'Complete patient record',
    description: 'Medical history, allergies, medications, notes, and visit history on the same chart, next to the odontogram, the facial map, and the files you already use.',
  },
  receituario: {
    title: 'Prescriptions you can print',
    description: 'The dentist fills in the prescription and prints it or saves a PDF with the patient and clinic details.',
  },
  atestado: {
    title: 'Sick note and attendance statement',
    description: 'The dentist issues and prints them with the date and time of the visit.',
  },
  'pedido-exame-encaminhamento': {
    title: 'Exam request and referral',
    description: 'A standard document to request an exam or refer the patient, ready to print.',
  },
  'termo-consentimento': {
    title: 'Consent form',
    description: 'Templates to give the patient, with printing and a record on the chart.',
  },
  'plano-tratamento-orcamento': {
    title: 'Treatment plan and estimate',
    description: 'Procedures, prices, and payment terms to show the patient before treatment starts.',
  },
  'financeiro-clinica': {
    title: 'Clinic finances',
    description: 'Accounts receivable and marking a visit as paid in cash, Pix, or card. Separate from the ÁgilOdonto subscription.',
  },
  'producao-comissao': {
    title: 'Production and commission by dentist',
    description: 'How much each dentist produced in the period and the commission agreed with the clinic.',
  },
  'estoque-materiais': {
    title: 'Supply inventory',
    description: 'Stock in and stock out, with an alert when a supply reaches its minimum.',
  },
  'convenios-ficha': {
    title: 'Insurance on the patient chart',
    description: 'The patient’s plan and a record of insured visits, without a connection to insurers for now.',
  },
  'relatorios-clinica': {
    title: 'Clinic reports',
    description: 'Missed visits, new patients, and production for the period, without a spreadsheet.',
  },
  'whatsapp-automatico': {
    title: 'Automatic WhatsApp',
    description: 'Appointment reminders and confirmation by WhatsApp, in addition to the email that already goes out.',
  },
  'lista-espera': {
    title: 'Waiting list',
    description: 'A queue of patients to fill a slot when one opens on the schedule.',
  },
  'consultas-recorrentes': {
    title: 'Recurring appointments',
    description: 'Repeat follow-ups and maintenance visits on the schedule without booking them one by one.',
  },
  'lembrete-retorno': {
    title: 'Follow-up reminder',
    description: 'A notice when the patient’s review is coming up, so the clinic can call at the right time.',
  },
  'exportar-dados': {
    title: 'Export the clinic’s data',
    description: 'A copy of patients and the schedule so the clinic can take its own data whenever it wants.',
  },
  'assinatura-pix': {
    title: 'Pay the ÁgilOdonto subscription with Pix',
    description: 'Pay the plan with Pix. Card payment stays available.',
  },
};

const es = {
  'prontuario-paciente': {
    title: 'Historia clínica completa del paciente',
    description: 'Anamnesis, alergias, medicamentos, notas e historial de consultas en la misma ficha, junto al odontograma, el mapa facial y los archivos que ya usas.',
  },
  receituario: {
    title: 'Recetas para imprimir',
    description: 'El profesional completa la receta y la imprime o genera el PDF con los datos del paciente y de la clínica.',
  },
  atestado: {
    title: 'Certificado y constancia de asistencia',
    description: 'El profesional los emite e imprime con la fecha y la hora de la consulta.',
  },
  'pedido-exame-encaminhamento': {
    title: 'Pedido de examen y derivación',
    description: 'Un documento estándar para solicitar un examen o derivar al paciente, listo para imprimir.',
  },
  'termo-consentimento': {
    title: 'Consentimiento informado',
    description: 'Modelos para entregar al paciente, con impresión y registro en la ficha.',
  },
  'plano-tratamento-orcamento': {
    title: 'Plan de tratamiento y presupuesto',
    description: 'Procedimientos, valores y condiciones de pago para mostrar al paciente antes de empezar.',
  },
  'financeiro-clinica': {
    title: 'Finanzas de la clínica',
    description: 'Cuentas por cobrar y registro del pago de la consulta en efectivo, Pix o tarjeta. Va aparte de la suscripción de ÁgilOdonto.',
  },
  'producao-comissao': {
    title: 'Producción y comisión por profesional',
    description: 'Cuánto produjo cada profesional en el período y la comisión acordada con la clínica.',
  },
  'estoque-materiais': {
    title: 'Inventario de materiales',
    description: 'Entrada y salida de materiales, con aviso cuando el stock llega al mínimo.',
  },
  'convenios-ficha': {
    title: 'Convenios en la ficha del paciente',
    description: 'El convenio del paciente y el registro de la consulta convenida, sin integración con las operadoras por ahora.',
  },
  'relatorios-clinica': {
    title: 'Informes de la clínica',
    description: 'Inasistencias, pacientes nuevos y producción del período, sin una planilla.',
  },
  'whatsapp-automatico': {
    title: 'WhatsApp automático',
    description: 'Recordatorio y confirmación de la consulta por WhatsApp, además del correo que ya se envía.',
  },
  'lista-espera': {
    title: 'Lista de espera',
    description: 'Una fila de pacientes para ocupar un horario cuando se libera en la agenda.',
  },
  'consultas-recorrentes': {
    title: 'Consultas recurrentes',
    description: 'Controles y mantenimientos repetidos en la agenda, sin agendarlos uno por uno.',
  },
  'lembrete-retorno': {
    title: 'Recordatorio de control',
    description: 'Un aviso cuando se acerca la revisión del paciente, para que la clínica llame en el momento justo.',
  },
  'exportar-dados': {
    title: 'Exportar los datos de la clínica',
    description: 'Una copia de los pacientes y de la agenda para que la clínica se lleve sus datos cuando quiera.',
  },
  'assinatura-pix': {
    title: 'Pagar la suscripción de ÁgilOdonto con Pix',
    description: 'Pago del plan con Pix. La tarjeta sigue disponible.',
  },
};

export const roadmapItemsPt = build(pt);
export const roadmapItemsEn = build(en);
export const roadmapItemsEs = build(es);
